<template>
	<div class="template_box">
		<div class="content_box">
			<goBack :page_title="page_title"></goBack>
			<el-form class="ruleForm" ref="ruleForm" :model="postreport" :rules="rules" label-position="top" label-width="auto">
				<div class="title">{{ $t('postreportArr.report_title') }}</div>
				
				<el-form-item label="" prop="reasons" width="0">
					<div class="reportList">
						<div class="reportName" v-for="item in reportList" :key="item.id" @click="toggleSelection(item.value)">
							<input type="checkbox" aria-label="Report Name Checkbox" :value="item.value" v-model="postreport.reasons" @click="toggleSelection(item.value)">
							<span class="reportLabel">{{ item.label }}</span>
						</div>
					</div>
				</el-form-item>
				
				<el-form-item class="remark_box" label="" prop="remark" width="0">
					<!-- 将这里的普通输入框改为文本域，并设置相关属性 -->
					<textarea v-model="postreport.remark" aria-label="Postre port remark textarea" rows="5" maxlength="500" :placeholder="placeholder" @input="limitCharacters($event)"></textarea>
					<div class="right-corner-counter">{{ characterLimitText }}</div>
				</el-form-item>
			
				<el-form-item>
					<div class="submitForm_box">
						<el-button :disabled="edit_btn" class="submitForm" type="primary" @click="submitForm()">{{ $t('buttonArr.Submit') }}</el-button>
					</div>
			  </el-form-item>
			</el-form>
		</div> 
	</div>
</template>

<script>
import { post_community_postreport } from '@/api/community.js'
import { rules } from "./js/postreport_rule.js"
import { createReportList } from "./js/reportList.js";
import VueI18n from '../../i18n/i18n';

export default {
	name: 'post-report',
	
	data() {
		return {
			page_title: this.$t('postreportArr.page_title'),
			postreport: {
				post_id: this.$route.params.post_id,
				reasons: [],  //举报原因 array 必填
				remark: "", //说明 选填
			},
			placeholder: this.$t('postreportArr.remark_placeholder'),
			reportList: [],
			rules: rules,
			is_required: false,
			edit_btn: true,
			currentLength: 0,
			remarkMaxLength: 500,
		};
	},
	
	computed: {
	   characterLimitText() {
	      return `${this.currentLength}/${this.remarkMaxLength}`;
	   }
	},
	
	// 监听
	watch: {
		"postreport": {
			handler: function (newValue, oldValue) {
				if(this.validate_all()){
					this.edit_btn = false
				}else{
					this.edit_btn = true
				}
			},
			deep: true
		},
	},
	
	
	beforeRouteLeave(to, from, next) {
		console.log('路由正在离开当前页面');
		this.postreport = {
			post_id: '',
			reasons: [],  //举报原因 array 必填
			remark: "", //说明 选填
		}
	   // 完成相关操作后，调用 next() 允许路由跳转
	   next();
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
		this.reportList = createReportList();
	},
  
	mounted() {
		// this.post_community_posts()
   },
	
	methods: {
		// 点击提交验证
		submitForm() {
			console.log(this.postreport.reasons); // 这里可以根据需求将其发送给后端或者做其他处理，此处先简单打印出来
			
			if(!this.validate_all()){
				this.$message(this.$t('postreportArr.validate_all'), "error")
			}
			
			console.log(this.is_required)
			this.post_community_postreport()
		},
	
		// 验证全部
		validate_all() {
			console.log(this.postreport.reasons); // 这里可以根据需求将其发送给后端或者做其他处理，此处先简单打印出来
			let that = this
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					that.is_required = true
					return true
				} else {
					that.is_required = false
					return false
				}
			})
			
			return this.is_required
		},
		// 验证
		validate_name(name) {
		  this.$refs.ruleForm.validateField(name, (val) => {
		    if (!val) {
		      return true
		    } else {
		      return false
		    }
		  })
		},
		
		//类型选择
		toggleSelection(value) {
		   const index = this.postreport.reasons.indexOf(value);
		   if (index === -1) {
		      this.postreport.reasons.push(value);
		   } else {
		      this.postreport.reasons.splice(index, 1);
		   }
			this.validate_name("reasons")
		},
		
		// 问题输入判断, 定义一个方法来限制文本域的字符数
		limitCharacters(event) {
			const value = event.target.value;
			if (value.length > 500) {
			  // 如果超过最大字符数，截断输入内容
			  this.postreport.remark = value.slice(0, 500);
			}
			this.validate_name("remark")
			this.currentLength = event.target.value.length;
		},
		
		//举报 (帖子)
		post_community_postreport(){
			let obj = {
				post_id: this.postreport.post_id,
				reasons: this.postreport.reasons,  //举报原因 array 必填
				remark: this.postreport.remark, //说明 选填
			}
			post_community_postreport(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.success_fun()
				}else{
					this.exception_handling(res, "postreport")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postreport")
		   })
		},
		
		// 成功处理
		success_fun(){
			this.$message(this.$t('tipsArr.Feedback_success'), 'success')
			let that = this
			setTimeout(()=>{
				that.goBackOrToHome()
			},1500)
		},
		
		//异常处理
		exception_handling(err){
			this.loading = false
			if(err.code == 4026){
				//已经反馈过了 重复反馈
				this.$message(this.$t('tipsArr.reported_post'), 'error')
			}else{
				this.$errorMessage(err)
				// this.$message(err.data.message, 'error')
			}
		},
		
		// 如果存在上一页，调用方法跳转
		goBackOrToHome() {
			console.log(this.$router.history)
		   const router = this.$router;
			// this.$router.go(-1)
			if (router.go(-1)) {
			  // 有上一页，返回上一页
			  router.go(-1);
			} else {
			  // 没有上一页，导航到首页（这里假设首页的路由名为'home'，你需要替换成实际的首页路由名称）
			  router.push({ name: 'home' });
			}
			// if (router.history.length > 1) {
			//   // 有上一页，返回上一页
			//   router.go(-1);
			// } else {
			//   // 没有上一页，导航到首页（这里假设首页的路由名为'home'，你需要替换成实际的首页路由名称）
			//   router.push({ name: 'home' });
			// }
		}
	}
};
</script>

<style lang="less" scoped>
	*{
		margin: 0;
		padding: 0;
	}
	.ruleForm{
		margin-top: 20px;
	}
	.title{
		font-size: 16px;
		line-height: 1.5;
	}
	.reportList{
		margin-top: 20px;
	}
	.reportName{
		margin-top: 15px;
		font-size: 14px;
		line-height: 1.5;
		cursor: pointer;
	}
	.reportLabel{
		margin-left: 10px;
	}
	.remark_box{
		margin-top: 40px;
		width: 100%;
		position: relative;
		textarea{
			font-size: 14px;
			width: 100%;
			background-color: #f9f9f9;
			padding: 5px;
			border-radius: 8px;
			color: #000000;
			resize: vertical; /* 只允许垂直方向（高度）拉升 */
			min-height: 10em;
			max-height: 50em; /* 假设一行文本高度大约是1em，设置最大高度为50行对应的高度，你可以根据实际文本行高情况调整这个值 */
			width: 100%; /* 确保宽度占满父容器，并且不能手动拉伸宽度 */
			box-sizing: border-box; /* 让宽度包含边框和内边距等，避免出现宽度超出预期等问题 */
		}
		textarea::placeholder{
			color: #999999;
		}
		.right-corner-counter {
			position: absolute;
			right: 0;
			margin-bottom: 22px;
			margin-right: 9px;
			bottom: 0;
			z-index: 99;
			width: 60px;
			height: 15px;
			line-height: 1;
			text-align: right;
			font-size: 12px;
			color: #666666;
			// color: #999999;
		}
	}
	.submitForm_box{
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: 10px;
		.submitForm{
			width: 100%;
			max-width: 300px;
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 20px;
			font-size: 14px;
			background: #06f;
        	border: 1px #06f solid;
		}
	}
	.reportName input[type="checkbox"] {
		background-color: #06f !important;
		border-color: #06f;
		// background-color: #409eff !important;
		// border-color: #409eff;
	}


	@media screen and (min-width: 1024px) {
		.template_box{
			background-color: #ffffff;
		}
		.content_box{
			width: 100%;
			height: 100%;
			padding: 10px;
		}
	}
	@media screen and (max-width: 1024px) {
		.template_box{
			background-color: transparent;
		}
		.content_box{
			width: 100%;
			height: 100%;
			padding: 0px;
		}
	}
</style>
